import clsx from "classnames";
import type { FC } from "react";
import { useMemo } from "react";
import type { ListContextType, ListProps } from "./List.types";
import { ListContext } from "./ListContext";
import ListItem from "./ListItem";

export const EXCLUDED_LIST_ITEM_STYLES = ["number", "circled-number", "bullet", "numbered"];

export const List: FC<ListProps> & { Item: typeof ListItem } = ({
	children,
	itemStyle,
	variant,
	size,
	className,
	inline,
	spacing,
}) => {
	const contextValue: ListContextType = useMemo(
		() => ({
			itemStyle,
		}),
		[itemStyle],
	);

	const classes = clsx(
		"list-style",
		EXCLUDED_LIST_ITEM_STYLES.includes(itemStyle) && `list-style-${itemStyle}`,
		variant && `list-${variant}`,
		size && `list-${size}`,
		inline && "list-inline",
		spacing && `list-spacing-${spacing}`,
		className,
	);

	return (
		<ListContext.Provider value={contextValue}>
			<ul className={classes}>{children}</ul>
		</ListContext.Provider>
	);
};

List.Item = ListItem;
